import { MessageService } from 'primeng/primeng';
import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { Cluster } from '../../models/loyalty-cluster.model';
import { ListMetadata } from '../../models/list-metadata.model';

@Injectable()
export class LoyaltyClusterService {

  public baseUrl = '/koncentro-loyalty';
  private cache = new Map<string, Cluster>();
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }


  get(clusterId): Observable<Cluster> {

    if (this.cache.has(clusterId)) {
      return Observable.of(this.cache.get(clusterId));
    }

    return this.http.get(this.baseUrl + '/cluster/' + clusterId).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }

  list (
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number,
      flg_state?: string
  ): Observable <{data: Array<Cluster>, metadata: ListMetadata}> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir, flg_state);
    console.log('PARAMS',params);
    //return this.http.get(this.baseUrl + '/cluster?' + params.toString());
    //return this.http.getPaged(this.baseUrl + '/cluster?' + params.toString());
    return this.http.getPaged(this.baseUrl + '/cluster' + '/getClusterList?' + params.toString());
  }

  update(cluster: Cluster): Observable<Cluster> {
    return this.http.put(this.baseUrl + '/cluster/' + cluster.id, cluster).map(res => {
      this.cache.delete(cluster.id);
      return res;
    });
  }

  create(cluster: Cluster): Observable<Cluster> {
    return this.http.post(this.baseUrl + '/cluster/' , cluster );
  }

  remove(clusterId): Observable<Cluster> {
    return this.http.delete(this.baseUrl + '/cluster/' + clusterId).map(res => {
      this.cache.delete(clusterId);
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      return res;
    });
  }
  recover(cluster) {
    return this.http.put(this.baseUrl + "/cluster/recover/" + cluster.id, cluster)
      .map(res => {
        this.cache.delete(cluster.id);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/ClusterDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-cluster.service.ts